import StackTrace from 'stacktrace-js';

interface AugmentedError extends Error {
  appName: string | null;
}

function formatStacktraceOutput(
  errorName: string,
  errorMessage: string,
  stackframes: StackTrace.StackFrame[]
): string {
  const stackWithSourcemapsTranslation = stackframes
    .map(
      ({ functionName, fileName, lineNumber, columnNumber }) =>
        `at ${functionName} (${fileName}:${lineNumber}:${columnNumber})`
    )
    .join('\n');

  return `${errorName}: ${errorMessage}\n${stackWithSourcemapsTranslation}`;
}

function extractAppNameFromRawStacktrace(stacktrace: string): string | null {
  const [microAppNameMatch] = stacktrace.match(/\w?[-\w]*-app\.min\.js/) ?? [];

  if (microAppNameMatch) {
    return microAppNameMatch.replace('-app.min.js', '');
  }

  return null;
}

function decodeMinifiedStacktrace(error: Error): Promise<AugmentedError> {
  return StackTrace.fromError(error).then((stackframes) => {
    const augmented = error as AugmentedError;
    const appName = extractAppNameFromRawStacktrace(augmented.stack ?? '');

    const prefix = appName ? `[${appName}-app] ` : '';
    augmented.message = `${prefix}${augmented.message}`;
    augmented.appName = appName;
    augmented.stack = formatStacktraceOutput(
      augmented.name,
      augmented.message,
      stackframes
    );

    return augmented;
  });
}

export default decodeMinifiedStacktrace;
